import { useEffect, useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import { Icon } from '~/components/ui/icons/icon.tsx'
import { AppBar } from './app-bar.tsx'
import DrawerNavigator, { type DrawerItem } from './drawer-navigator.tsx'
import {
  AdminTransportTableEnum,
  TransportTypeEnum,
  TransportTypeEnumSpanish,
} from 'types/enums.ts'

export const adminDrawerItems: DrawerItem[] = [
  {
    title: 'Empresas',
    icon: <Icon name="brands" size="drawer" />,
    href: '/admin/companies',
    children: [
      {
        title: 'Usuarios',
        icon: { name: 'user' },
        href: '/admin/shipper-users',
      },
      {
        title: 'Empresas',
        icon: { name: 'brands' },
        href: '/admin/shipper-companies',
      },
      {
        title: 'Smart Connect',
        icon: { name: 'globe' },
        href: '/admin/smart-connect',
        isExactPath: true,
      },
      {
        title: 'Facturas',
        icon: { name: 'invoice' },
        href: '/admin/invoices',
      },
      {
        title: 'Tarifas',
        icon: { name: 'export' },
        href: '/admin/fees',
      },
    ],
  },
  {
    title: 'Transportistas',
    icon: <Icon size="drawer" className="-ml-[4px]" name="truck" />,
    href: '/admin/carriers',
    children: [
      {
        title: 'Usuarios',
        icon: { name: 'user' },
        href: '/admin/carrier-users',
      },
      {
        title: 'Empresas',
        icon: { name: 'brands' },
        href: '/admin/carrier-companies',
      },
    ],
  },
  {
    title: 'Envíos',
    icon: <Icon size="drawer" className="-ml-[4px]" name="suppliers-small" />,
    href: `/admin/transport-requests/${TransportTypeEnum.LAND}/${AdminTransportTableEnum.SHIPPERS}`,
    isExactPath: true,
    children: [
      {
        title: TransportTypeEnumSpanish.land,
        icon: { name: 'road-bus' },
        href: `/admin/transport-requests/${TransportTypeEnum.LAND}/${AdminTransportTableEnum.SHIPPERS}`,
        hrefMatch: `/admin/transport-requests/${TransportTypeEnum.LAND}`,
      },
      {
        title: TransportTypeEnumSpanish.sea,
        icon: { name: 'ship' },
        href: `/admin/transport-requests/${TransportTypeEnum.SEA}/${AdminTransportTableEnum.SHIPPERS}`,
        hrefMatch: `/admin/transport-requests/${TransportTypeEnum.SEA}`,
      },
      {
        title: TransportTypeEnumSpanish.air,
        icon: { name: 'plane' },
        href: `/admin/transport-requests/${TransportTypeEnum.AIR}/${AdminTransportTableEnum.SHIPPERS}`,
        hrefMatch: `/admin/transport-requests/${TransportTypeEnum.AIR}`,
      },
    ],
  },
  {
    title: 'Docs. Control',
    icon: <Icon name="file" size="drawer" />,
    href: '/admin/control-documents',
  },
  {
    title: 'Provincias',
    icon: <Icon name="config" size="drawer" />,
    href: '/admin/provinces',
  },
]

type Props = {
  children: React.ReactNode
}

export const AdminLayout = ({ children }: Props) => {
  const isMobile = useMediaQuery({
    query: '(max-width: 640px)',
  })
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean | undefined>(
    undefined,
  )

  useEffect(() => {
    if (isDrawerOpen === undefined) {
      setIsDrawerOpen(!isMobile)
    }
  }, [isMobile, isDrawerOpen])

  useEffect(() => {
    if (isMobile && isDrawerOpen) {
      setIsDrawerOpen(false)
    }
  }, [isMobile])

  return (
    <div className="flex">
      <DrawerNavigator
        isMobile={true}
        items={adminDrawerItems}
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      />
      <DrawerNavigator
        isMobile={false}
        items={adminDrawerItems}
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      />
      <div className="w-full overflow-hidden bg-[#FDFDFE]">
        <AppBar
          onHamburgerMenu={() => setIsDrawerOpen(!isDrawerOpen)}
          className="max-w-full"
        />
        <div className="mt-10 flex-1">{children}</div>
      </div>
    </div>
  )
}
